import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
// import { Button } from "react-bootstrap";
// import Loader from "../../ui/Loader";
import { validateLeadFolloupForm } from "../functions/LeadValidations";
import { addLead, addLeadFollowup } from "../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { leadPlanTypes, times } from "../../common-data/DropdowData";
import SelectDropdownLabel from "../../components-react/SelectDropdownLabel";
import {
  currentMonthCurrentDate,
  formatDateTime,
} from "../../common-data/Converts";
import FormProfile from "../common/FormProfile";
import {
  fetchCustomerIntentData,
  fetchFollowupStatusData,
} from "../../../redux/reducers/apiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";

const FollowInfoFormV1 = ({
  userInfoData,
  rowData,
  followupStage,
  callFunction,
  allFollowups,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading, postPutLoading1 } = useSelector(
    (state) => state.common
  );
  const { customerIntentCategory, followupStatuses } = useSelector(
    (state) => state.api
  );

  const copiedFollowups = [...allFollowups];
  const filteredFollowups = copiedFollowups.sort((a, b) =>
    moment(b.scheduled_on)?.tz("Asia/Kolkata")?.diff(a.scheduled_on)
  );
  const prevFollowupData = filteredFollowups[0];

  const { lead_id: leadId } = rowData || {};

  const [timesOption, setTimesOption] = useState([]);
  const initialFormValues = {
    scheduledOn: "",
    selCustomerIntent: "",
    followupStatus: "",
    remarks: "",
    nextFollowupDate: "",
    nextFollowupTime: "",
    expectedCloserDate: "",

    selectedPlan: "",
    leadValueAmount: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [customerIntents, setCustomerIntents] = useState([]);
  const [followupStatus, setFollowupStatus] = useState([]);

  const is_Next_Followup_Required =
    formValues.followupStatus &&
    formValues.followupStatus?.next_followup_required;
  const is_Plan_Info_Required =
    formValues.followupStatus && formValues.followupStatus?.price_required;

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    if (name === "nextFollowupDate") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        nextFollowupTime: "",
        expectedCloserDate: value,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    if (name === "selCustomerIntent") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        followupStatus: "",
      }));
      setFollowupStatus([]);
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleUpdateFollowup = async (
    payload,
    userDataAdd,
    userDataExpClosureDate
  ) => {
    const method = "PUT";
    const endpoint = addLeadFollowup;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        handleAddFollowup(userDataAdd);
        setIsSubmit(false);
        callFunction();

        handleChangeCloserDate(userDataExpClosureDate);
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleAddFollowup = async (
    payload,
    isAddUpdate,
    userDataExpClosureDate
  ) => {
    const method = "POST";
    const endpoint = addLeadFollowup;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();

        handleChangeCloserDate(userDataExpClosureDate);
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleChangeCloserDate = async (payload) => {
    const method = "PUT";
    const endpoint = addLead;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        console.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making PUT request:", error);
    }
  };

  function getCustomerIntent(filters) {
    dispatch(
      fetchCustomerIntentData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getFollowupStatuses(filters) {
    dispatch(
      fetchFollowupStatusData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onSumitForm = (e) => {
    e.preventDefault();

    const errors = validateLeadFolloupForm(formValues);

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];

      setTimeout(() => {
        const errorElement =
          document.querySelector(`[name="${firstErrorField}"]`) ||
          document.querySelector(`.formError`);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
          errorElement.focus();
        }
      }, 100);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    const filters = {
      page: 1,
      limit: 10,
      status: "active",
    };

    getCustomerIntent(filters);
  }, []);

  useEffect(() => {
    if (formValues.selCustomerIntent?.value) {
      const filters = {
        page: 1,
        limit: 200,
        status: "active",
        intent_id: formValues.selCustomerIntent.value,
      };

      getFollowupStatuses(filters);
    }
  }, [formValues.selCustomerIntent]);

  useEffect(() => {
    if (
      customerIntentCategory?.status &&
      customerIntentCategory?.data?.length > 0
    ) {
      const allIntents = customerIntentCategory?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.name || "",
        next_followup_required: item?.next_followup_required || 0,
      }));

      setCustomerIntents(allIntents);
    } else {
      setCustomerIntents([]);
    }
  }, [customerIntentCategory]);

  useEffect(() => {
    if (followupStatuses?.status && followupStatuses?.data?.length > 0) {
      const allFollowups = followupStatuses?.data?.map((item) => ({
        value: item?.value || "",
        label: item?.display_label || "",
        next_followup_required: item?.next_followup_required || false,
        price_required: item?.price_required || 0,
      }));

      setFollowupStatus(allFollowups);
    } else {
      setFollowupStatus([]);
    }
  }, [followupStatuses]);

  useEffect(() => {
    const today = new Date();
    let filteredTimesOptions;

    if (formValues.nextFollowupDate) {
      const selectedDate = new Date(formValues.nextFollowupDate);
      const currentHour = today.getHours();
      const currentMinute = today.getMinutes();

      if (selectedDate.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
        filteredTimesOptions = times.filter((time) => {
          const [timeHour, timeMinute] = time.value.split(":").map(Number);
          return (
            timeHour > currentHour ||
            (timeHour === currentHour && timeMinute >= currentMinute)
          );
        });
      } else {
        filteredTimesOptions = times;
      }
    } else {
      filteredTimesOptions = [];
    }

    setTimesOption(filteredTimesOptions);
  }, [formValues.nextFollowupDate]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const currentDate = moment().tz("Asia/Kolkata");

      if (filteredFollowups.length > 0) {
        const nextFollowupDateTime = moment(
          `${formValues.nextFollowupDate} ${formValues.nextFollowupTime?.value}`,
          "YYYY-MM-DD HH:mm"
        )
          ?.tz("Asia/Kolkata")
          ?.utcOffset("+05:30");
        const prevNextFollowUpDate = moment(prevFollowupData?.scheduled_on)
          ?.tz("Asia/Kolkata")
          ?.utcOffset("+05:30");

        const differenceInMinutes = nextFollowupDateTime.diff(
          currentDate,
          "minutes"
        );
        const differenceInHoursDNP = Math.abs(
          nextFollowupDateTime.diff(prevNextFollowUpDate, "hours")
        );

        // Validation 2: If the current follow-up status is DNP and nextFollowupDateTime is before 3 hours or after 24 hours
        if (
          formValues.followupStatus === "dnp" &&
          (differenceInHoursDNP < 2 || differenceInHoursDNP > 24)
        ) {
          toast.error(
            "Next follow-up date and time should be between 3 hours and 24 hours for DNP status."
          );
          return;
        }

        // Validation 3: Ensure nextFollowupDateTime is at least 30 minutes after the current time
        else if (differenceInMinutes < 30) {
          toast.error(
            "Next follow-up date and time should be at least 30 minutes after the current time."
          );
          return;
        } else {
          const userDataUpdate = {
            lead_id: leadId,
            uid: prevFollowupData?.uid,
            customer_intent_id: formValues.selCustomerIntent?.value || "",
            follow_up_status: formValues.followupStatus?.value || "",
            scheduled_on: prevFollowupData?.scheduled_on || "",
            next_follow_up_date:
              formValues.nextFollowupDate && formValues.nextFollowupTime?.value
                ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
                : "",
            remarks: formValues.remarks,
          };

          const userDataAdd = {
            lead_id: leadId,
            followUpDetails: [
              {
                added_by: userInfoData?.uid || userInfoData?.user_id,
                follow_up_status: "pending",
                scheduled_on:
                  formValues.nextFollowupDate &&
                  formValues.nextFollowupTime?.value
                    ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
                    : "",
                next_follow_up_date: "",
                remarks: "",
              },
            ],
          };

          const userDataExpClosureDate = {
            lead_id: leadId,
            uid: prevFollowupData?.uid,
            expected_closure_date: formValues.expectedCloserDate || "",
            customer_intent_id: formValues.selCustomerIntent?.value || "",
          };

          const handleConfirm = async () => {
            handleUpdateFollowup(
              userDataUpdate,
              userDataAdd,
              userDataExpClosureDate
            );
          };

          showConfirmAlert(
            handleConfirm,
            `Are you sure!`,
            "Edit Form",
            "Add Follow-up"
          );
        }
      } else {
        const userData = {
          lead_id: leadId,
          followUpDetails: [
            {
              added_by: userInfoData?.uid || userInfoData?.user_id,
              customer_intent_id: formValues.selCustomerIntent?.value || "",
              follow_up_status: formValues.followupStatus?.value || "",
              scheduled_on: "",
              next_follow_up_date:
                formValues.nextFollowupDate &&
                formValues.nextFollowupTime?.value
                  ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
                  : "",
              remarks: formValues.remarks,
              is_first: 1,
            },
            {
              added_by: userInfoData?.uid || userInfoData?.user_id,
              follow_up_status: "pending",
              scheduled_on:
                formValues.nextFollowupDate &&
                formValues.nextFollowupTime?.value
                  ? `${formValues.nextFollowupDate} ${formValues.nextFollowupTime.value}`
                  : "",
              next_follow_up_date: "",
              remarks: "",
            },
          ],
        };

        const userDataExpClosureDate = {
          lead_id: leadId,
          expected_closure_date: formValues.expectedCloserDate || "",
          customer_intent_id: formValues.selCustomerIntent?.value || "",
        };

        const handleConfirm = async () => {
          handleAddFollowup(userData, true, userDataExpClosureDate);
        };

        showConfirmAlert(
          handleConfirm,
          `Are you sure!`,
          "Edit Form",
          "Add Follow-up"
        );
      }
    }
  }, [isSubmit, formErrors]);

  console.log(
    "formErrors=> ",
    formErrors,
    isSubmit && Object.keys(formErrors)?.length === 0
  );

  return (
    <div className="form-container lead-form-container">
      <div className="profile-form-info">
        <FormProfile rowData={rowData} />
      </div>

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox disabled">
            <label htmlFor="followupStage" className={`formInputLabel`}>
              Follow-up Stage
            </label>

            <input
              type="text"
              className="formInput"
              name="followupStage"
              placeholder={`${followupStage || "NA"}`}
              disabled
            />
          </div>

          <div className="formInputBox disabled">
            <label htmlFor="prevFollowupDate" className={`formInputLabel`}>
              Previous Follow-up Date
            </label>

            <input
              type="text"
              className="formInput"
              name="prevFollowupDate"
              placeholder={`${
                prevFollowupData?.scheduled_on
                  ? formatDateTime(prevFollowupData.scheduled_on)
                  : "NA"
              }`}
              disabled
            />
          </div>

          <div className="formInputBox disabled">
            <label htmlFor="selCustomerIntent" className={`formInputLabel`}>
              Customer Intent <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selCustomerIntent ? "formError" : ""
              }`}
            >
              <SelectDropdownLabel
                options={customerIntents}
                selectedOption={formValues.selCustomerIntent}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selCustomerIntent", selectedValue)
                }
                name="Customer Intent"
                preventKeyboardOpen={true}
              />
            </div>
          </div>

          {formValues.selCustomerIntent ? (
            <div className="formInputBox disabled">
              <label htmlFor="followupStatus" className={`formInputLabel`}>
                Follow-up Status <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.followupStatus ? "formError" : ""
                }`}
              >
                <SelectDropdownLabel
                  options={followupStatus}
                  selectedOption={formValues.followupStatus}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("followupStatus", selectedValue)
                  }
                  name="Follow-up Status"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>
          ) : null}

          {formValues.selCustomerIntent ? (
            <div className="formInputBox">
              <label htmlFor="nextFollowupDate" className={`formInputLabel`}>
                Next Followup Date/Time{" "}
                {is_Next_Followup_Required ? (
                  <span className="required">*</span>
                ) : null}
              </label>

              <div className="two-input">
                <input
                  type="date"
                  className={`formInput ${
                    formValues.nextFollowupDate ? "date-has-value" : ""
                  } ${formErrors?.nextFollowupDate ? "formError" : ""}`}
                  name="nextFollowupDate"
                  value={formValues.nextFollowupDate}
                  onChange={onChangeInput}
                  min={currentMonthCurrentDate}
                  placeholder="Select date"
                />

                <div
                  className={`commonWrapper ${
                    formErrors.nextFollowupTime ? "formError" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={timesOption}
                    selectedOption={formValues.nextFollowupTime}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("nextFollowupTime", selectedValue)
                    }
                    name="Time"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>
            </div>
          ) : null}

          {is_Plan_Info_Required ? (
            <>
              <div className="formInputBox">
                <label htmlFor="selectedPlan" className={`formInputLabel`}>
                  Plan <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedPlan ? "formError" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={leadPlanTypes}
                    selectedOption={formValues.selectedPlan}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedPlan", selectedValue)
                    }
                    name="Plan"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>

              <div className="formInputBox">
                <label htmlFor="leadValueAmount" className={`formInputLabel`}>
                  Lead Value <span className="required">*</span>
                </label>

                <input
                  type="number"
                  placeholder="enter lead value"
                  className={`formInput ${
                    formErrors.leadValueAmount ? "formError" : ""
                  }`}
                  name="leadValueAmount"
                  value={formValues.leadValueAmount}
                  onChange={onChangeInput}
                  min={0}
                />
              </div>
            </>
          ) : null}

          <div className="formInputBox span2">
            <label htmlFor="remarks" className="formInputLabel">
              Add Remarks (Min 20 Characters - {formValues.remarks?.length || 0}
              ) <span className="required">*</span>
            </label>

            <textarea
              name="remarks"
              className={`formInput ${formErrors.remarks ? "formError" : ""}`}
              placeholder="Brief About First Followup"
              value={formValues.remarks}
              onChange={onChangeInput}
            ></textarea>
          </div>
        </div>

        <CloseSubmitBtn
          submitLabel={"📆 Schedule Follow-up"}
          closeLabel="Cancel"
          onSubmit={onSumitForm}
          onClose={closeModal}
          isLoading={postPutLoading || postPutLoading1}
        />
      </form>
    </div>
  );
};

export default FollowInfoFormV1;
